import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const FAQS = [
    {
        q: "What regions do you operate in?",
        a: "We are headquartered in Bengaluru, India, and serve clients pan-India as well as across APAC, the Middle East and globally, offering both remote and on-ground IT solutions.",
    },
    {
        q: "What industries do you specialize in?",
        a: "We have proven experience in energy, education, aviation, BFSI and hospitality, but our solutions are engineered to adapt to any industry.",
    },
    {
        q: "How does Syntera support AI integration?",
        a: "Through our dedicated AI Center of Excellence in Bengaluru, we offer AI-driven solutions spanning agentic workflows, LLM fine-tuning, speech intelligence and computer vision that boost personalization, automation and efficiency.",
    },
    {
        q: "Are your solutions customizable?",
        a: "Absolutely. We don't believe in one-size-fits-all. Every solution is tailored to your unique business needs, compliance landscape and scalability goals.",
    },
    {
        q: "Do you offer post-project support?",
        a: "Yes. We offer comprehensive post-deployment SLAs, including training, monitoring and maintenance, to ensure long-term success of every engagement.",
    },
    {
        q: "Can you help with digital transformation strategy?",
        a: "Yes. Our consulting practice helps you build and implement a digital strategy that is aligned with your business goals, from roadmap to execution.",
    },
];

export const Faq = () => (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
            <Reveal className="text-center">
                <Eyebrow>FAQs</Eyebrow>
                <h2 className="mb-4 font-syne text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="faq-heading">
                    Frequently asked questions
                </h2>
            </Reveal>

            <Reveal delay={0.15}>
                <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="faq-accordion">
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            className="rounded-xl border border-white/[0.08] bg-card2/50 px-6 transition-colors duration-300 data-[state=open]:border-volt/30"
                        >
                            <AccordionTrigger
                                data-testid={`faq-question-${i}`}
                                className="py-5 text-left font-syne text-base font-semibold text-slate-100 hover:text-volt hover:no-underline sm:text-lg"
                            >
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent data-testid={`faq-answer-${i}`} className="pb-5 text-sm leading-relaxed text-slate-400 sm:text-base">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
